import AppContext from "PFApp/app_context";
import NoItems from "PFApp/components/table/no_items";
import SimplePagination from "PFComponents/pagination/simple_pagination";
import React, { useContext } from "react";

import Pinned from "../pinned";
import RolesRowsConnected from "./roles_rows_connected";

const RolesListView = () => {
  const {
    store: {
      pages: {
        workflowPage: {
          roles: {
            data: { entries, meta, loading },
            fetchData,
            pinnedIds,
            setPinnedIds
          }
        }
      }
    }
  } = useContext(AppContext);

  const handlePaginationClick = (number) => {
    fetchData({ page: number });
  };

  const entriesUnpinned = entries.filter(({ id }) => !pinnedIds.includes(id)).map(({ activity }) => activity);
  const noItems = pinnedIds.length === 0 && entriesUnpinned.length === 0;

  return (
    <>
      {noItems && <NoItems itemType="role" />}
      <Pinned pinnedIds={pinnedIds} setPinnedIds={setPinnedIds} type="roles" />
      <RolesRowsConnected items={entriesUnpinned} isLoading={loading} />
      <div style={{ display: "flex" }}>
        <SimplePagination
          style={{ position: "sticky", left: "50%", transform: "translate(-50%, 0px)" }}
          currentPage={meta.page}
          handleClick={handlePaginationClick}
          totalPages={meta.totalPages}
        />
      </div>
    </>
  );
};

export default RolesListView;
